module.exports = __webpack_public_path__ + "static/media/zarinpal.553af8aa.svg";